<template>
  <li
    :class="filter.viewMode === 'list' ? 'item' : 'tile'"
    :style="{ opacity: item.isHidden ? '0.4' : undefined }"
  >
    <template v-if="filter.viewMode === 'list'">
      <div v-long-press>
        <div class="item-img-block" @click="onClickListImage">
          <template v-if="!isHouseShare">
            <img v-lazy="itemImage" class="item-img" />
          </template>
          <template v-else>
            <img v-lazy="houseShareImage1" class="item-img-house-share" />
            <img v-lazy="houseShareImage2" class="item-img-house-share" />
          </template>
          <img
            class="item-img-remake"
            src="../assets/remake.svg"
            v-if="item.customize || item.bodyCustomize || item.patternCustomize"
          />
          <img
            class="item-img-recipe"
            src="https://i0.wp.com/acnhcdn.com/latest/MenuIcon/PaperRecipe.png"
            v-if="item.sourceSheet === 'Recipes'"
          />
          <template v-if="!(item.variants && item.variants.length > 1)">
            <div v-if="stockCounts[0] > 1" class="t-stock">
              {{ stockCounts[0] }}
            </div>
            <div v-if="inWishlistFlags[0]" class="t-heart" />
          </template>
        </div>
      </div>
      <div class="item-center">
        <div>{{ itemName }}</div>
        <div class="item-note" v-if="item.sourceJa">
          {{ item.sourceJa.join("、") }}
        </div>
        <div class="item-note" v-if="item.seasonEventJa">
          {{ item.seasonEventJa }}
        </div>
        <div class="item-note" v-if="item.activeMonths">
          <div v-html="infoActiveMonths" />
          <div>
            <span v-html="infoActiveTimes" />
            <template v-if="item.weatherJa">, {{ item.weatherJa }}</template>
            <template v-if="item.whereHowJa"
              >, 場所: {{ item.whereHowJa }}</template
            >
            <template v-if="item.shadowJa"
              >, 魚影: {{ item.shadowJa }}</template
            >
          </div>
        </div>
        <template v-if="item.sourceSheet === 'Photos'">
          <div class="item-note" v-if="item.personality">
            性格: {{ item.personality }}
          </div>
          <div class="item-note" v-if="item.birthday">
            誕生日: {{ item.birthday }}
          </div>
        </template>
        <template>
          <div
            class="item-variants"
            v-if="
              item.variants &&
              (item.variants.length > 1 || item.variants[0].request)
            "
          >
            <div
              v-for="(variant, index) in item.variants"
              :key="variant.uniqueEntryId"
              v-long-press="index"
            >
              <CheckForList
                :value="checks[index]"
                :variant="variant"
                :variants="item.variants"
                :stock="stockCounts[index]"
                :isInWishlist="inWishlistFlags[index]"
                @click="onChangeCheck(index, index)"
              />
            </div>
            <span
              class="item-length"
              v-if="item.variants && item.variants.length > 1"
              >{{ item.variants.length }}種</span
            >
          </div>
        </template>
      </div>
      <button
        type="button"
        class="item-check-btn"
        @click="onClickAllCheck('list')"
        v-long-press
      >
        <span
          class="item-check"
          :class="{
            'item-check-1': allCheckState === 1,
            'item-check-2': allCheckState === 2,
          }"
        />
      </button>
    </template>
    <template v-else>
      <ul
        v-if="
          item.variants &&
          (filter.viewMode === 'tile' ||
            (filter.viewMode === 'tile2' && !item.cyrusCustomizePrice))
        "
        class="tile-variants"
      >
        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
        <li
          class="t"
          v-for="(index, i) in matchedVariants"
          :key="item.variants[index].uniqueEntryId"
          v-long-press="index"
        >
          <CheckForTile
            :name="i === 0 ? itemName : ''"
            :image="variantImages[index]"
            :houseShareImage1="houseShareImage1"
            :houseShareImage2="houseShareImage2"
            :value="checks[index]"
            :variant="item.variants[index]"
            :variants="item.variants"
            :isRemake="
              item.customize || item.bodyCustomize || item.patternCustomize
            "
            :isInWishlist="inWishlistFlags[i]"
            :stock="stockCounts[i]"
            @click="onChangeCheck(index, i)"
          />
        </li>
      </ul>
      <ul v-else class="tile-variants">
        <li class="t" v-long-press>
          <CheckForTile
            :name="itemName"
            :image="itemImage"
            :value="item.variants ? allCheckState : checks[0]"
            :isRecipe="item.sourceSheet === 'Recipes'"
            :isRemake="
              item.customize || item.bodyCustomize || item.patternCustomize
            "
            :isInWishlist="inWishlistFlags[0]"
            :stock="stockCounts[0]"
            :length="item.variants ? item.variants.length : undefined"
            @click="onClickAllCheck('tile2')"
          />
        </li>
      </ul>
    </template>
  </li>
</template>

<script>
import CheckForList from "./CheckForList";
import CheckForTile from "./CheckForTile";
import stampUrls from "../mixins/stampUrls";
import shareNpcImages from "../mixins/shareNpcImages";
import {
  inWishlistFlags,
  toDisplayItemName,
  stockCounts,
} from "../utils/utils";

export default {
  name: "Item",
  components: {
    CheckForList,
    CheckForTile,
  },
  mixins: [stampUrls, shareNpcImages],
  props: {
    collected: {
      type: [String, Array],
      default: "",
    },
    item: Object,
    filter: Object,
    isSearchMode: Boolean,
    isStatic: Boolean,
    isShared: {
      type: Boolean,
      default: false,
    },
    islandName: String,
  },
  directives: {
    "long-press": {
      bind(el, binding, vnode) {
        const listener = (e) => {
          vnode.context.showModal(e, binding.value);
        };
        vnode.context.longPressBound[binding.value] = listener;
        el.addEventListener("long-press", listener);
      },
      unbind(el, binding, vnode) {
        el.removeEventListener(
          "long-press",
          vnode.context.longPressBound[binding.value]
        );
        delete vnode.context.longPressBound[binding.value];
      },
    },
  },
  data() {
    return {
      checks: {},
      longPressBound: {},
    };
  },
  computed: {
    itemName() {
      return toDisplayItemName(this.item, this.islandName);
    },
    itemImage() {
      const item = this.item;
      if (item.variants) {
        return this.variantImages[0];
      } else {
        if (
          item.sourceSheet === "Recipes" ||
          item.sourceSheet === "Reactions"
        ) {
          return `https://nh-cdn.catalogue.ac/${item.image}`;
        } else if (item.iconImage) {
          return `https://nh-cdn.catalogue.ac/${item.iconImage}`;
        }
      }
      return "";
    },
    variantImages() {
      const variants = this.item.variants;
      let images = [];
      if (variants) {
        variants.forEach((variant) => {
          let image = "";
          if (this.item.shareImage) {
            image = this.shareNpcImages[this.item.shareImage];
          } else if (variant.stampImage) {
            image = this.stampUrls[variant.stampImage];
          } else {
            image =
              variant.image ||
              variant.storageImage ||
              variant.albumImage ||
              variant.inventoryImage;
            if (image !== "") {
              image = `https://nh-cdn.catalogue.ac/${image}`;
            }
          }
          images.push(image);
        });
      }
      return images;
    },
    houseShareImage1() {
      if (this.isHouseShare) {
        return `https://nh-cdn.catalogue.ac/${this.item.variants[0].image1}`;
      } else {
        return "";
      }
    },
    houseShareImage2() {
      if (this.isHouseShare) {
        return `https://nh-cdn.catalogue.ac/${this.item.variants[0].image2}`;
      } else {
        return "";
      }
    },
    isHouseShare() {
      return (
        this.item.houseShare && this.item.sourceSheet === "Paradise Planning"
      );
    },
    allCheckState() {
      const checks = Object.values(this.checks);
      let count2 = 0;
      for (let i = 0; i < checks.length; i++) {
        if (checks[i] === 0) {
          return 0;
        } else if (checks[i] === 2) {
          count2++;
        }
      }
      if (count2 === checks.length) {
        return 2;
      }
      return 1;
    },
    isShowDropdown() {
      return this.$store.getters.isShowDropdown;
    },
    matchedVariants() {
      const item = this.item;
      if (!item.variants) return null;

      if (!this.isSearchMode && item.matchedVariants) {
        return item.matchedVariants;
      } else {
        return "0123456789".substring(0, item.variants.length).split("");
      }
    },
    inWishlistFlags() {
      return inWishlistFlags(
        this.item,
        this.isShared,
        this.filter.viewMode === "list"
      );
    },
    isWishlistMode() {
      return this.$store.getters.isWishlistMode;
    },
    stockCounts() {
      return stockCounts(
        this.item,
        this.isShared,
        this.filter.viewMode === "list"
      );
    },
    infoActiveMonths() {
      const item = this.item;
      if (!item.activeMonths) {
        return null;
      } else if (item.activeMonths.northern.length === 12) {
        return "一年中";
      } else {
        const north = item.activeMonths.northern
          .map((month) => month.month)
          .join(", ");
        const south = item.activeMonths.southern
          .map((month) => month.month)
          .join(", ");
        return `北半球: ${north}月<br>南半球: ${south}月`;
      }
    },
    infoActiveTimes() {
      const item = this.item;
      if (!item.activeMonths) {
        return null;
      } else if (item.activeMonths.northern[0].isAllDay) {
        return "１日中";
      } else {
        const from1 = item.activeMonths.northern[0].activeHours[0][0];
        const to1 = item.activeMonths.northern[0].activeHours[0][1];
        if (item.activeMonths.northern[0].activeHours[1]) {
          const from2 = item.activeMonths.northern[0].activeHours[1][0];
          const to2 = item.activeMonths.northern[0].activeHours[1][1];
          return `${from1}〜${to1}時, ${from2}〜${to2}時`;
        } else {
          return `${from1}〜${to1}時`;
        }
      }
    },
  },
  watch: {
    collected() {
      this.checks = this.updateChecks(this.collected);
    },
  },
  mounted() {
    this.checks = this.updateChecks(this.collected);
  },
  methods: {
    updateChecks(collected) {
      let result = {};
      const item = this.item;
      collected = typeof collected === "string" ? collected : "";

      // No variants item
      if (item.uniqueEntryId) {
        const value = collected === "" ? 0 : collected === "0" ? 1 : 2;
        result[0] = value;
        return Object.assign({}, result);
      }
      // Variants item
      else if (item.variants) {
        for (let i = 0; i < item.variants.length; i++) {
          result[i] = 0;
        }
        if (collected !== "") {
          [].forEach.call(collected, function (string) {
            if (!isNaN(string)) {
              result[parseInt(string, 10)] = 1;
            } else {
              result[string.charCodeAt() - 65] = 2;
            }
          });
        }
      }
      return result;
    },
    updateCollected() {
      const checks = Object.values(this.checks);
      let result = "";
      for (let i = 0; i < checks.length; i++) {
        if (checks[i] === 1) {
          result = result + i;
        } else if (checks[i] === 2) {
          result = result + String.fromCharCode(i + 65);
        }
      }
      this.$emit("change", this.item.uniqueEntryId || this.item.name, result);
    },
    onClickListImage() {
      if (this.isWishlistMode && !this.isStatic) {
        this.updateWishlist(0, 0);
      }
    },
    onChangeCheck(index, i) {
      if (this.isShowDropdown || this.isStatic || this.item.isHidden) {
        return;
      }

      if (this.isWishlistMode && i !== undefined) {
        this.updateWishlist(index, i);
      } else if (this.stockCounts[index] > 1) {
        this.$emit("showModal", this.item, parseInt(index, 10));
      } else {
        const currentValue = this.checks[index];
        const nextValue = currentValue === 2 ? 0 : currentValue + 1;
        this.checks[index] = nextValue;
        this.updateCollected();
      }
    },
    onClickAllCheck(viewmode) {
      if (this.isShowDropdown || this.isStatic || this.item.isHidden) {
        return;
      }

      let totalVariantsStockCount = 0;
      this.stockCounts.forEach((count) => {
        if (count) totalVariantsStockCount += count;
      });
      if (this.isWishlistMode) {
        this.updateWishlist(0, 0, viewmode);
      } else if (totalVariantsStockCount > 1) {
        this.$emit("showModal", this.item, 0);
      } else {
        const nextState = this.allCheckState === 2 ? 0 : this.allCheckState + 1;
        let result = {};
        Object.keys(this.checks).forEach((key) => {
          result[key] = nextState;
        });
        this.checks = result;
        this.updateCollected();
      }
    },
    updateWishlist(index, i, viewmode) {
      const item = this.item;
      const itemKey = item.uniqueEntryId || item.name;
      const type = this.inWishlistFlags[i] ? "remove" : "add";

      if (item.fullMode && i > 0) {
        return;
      }

      if (viewmode === "list" && item.variants) {
        item.variants.forEach((variant, index) => {
          const entryId = `${itemKey}_${index}`;
          this.$store.commit(`${type}Wishlist`, entryId);
        });
      } else if (viewmode === "tile2" && type === "remove" && item.variants) {
        item.variants.forEach((variant, index) => {
          const entryId = `${itemKey}_${index}`;
          this.$store.commit("removeWishlist", entryId);
        });
      } else {
        const entryId = item.variants ? `${itemKey}_${index}` : itemKey;
        this.$store.commit(`${type}Wishlist`, entryId);
      }
      this.$emit("updateWishlist");
    },
    showModal(event, index) {
      event.preventDefault();
      this.$emit("showModal", this.item, index ? parseInt(index, 10) : 0);
    },
  },
};
</script>

<style scoped lang="scss">
// List item

.item {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 66px;
  padding: 0 0 0 0.75rem;
  margin: 0;
  border-bottom: 1px solid var(--app-btn-gray2);
  user-select: none;
}

.item-img-block {
  position: relative;
  cursor: pointer;
}

.item-img {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-right: 0.5rem;
  vertical-align: top;
  pointer-events: none;
  user-select: none;
}

.item-img-house-share {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  object-fit: contain;
  vertical-align: top;
  pointer-events: none;
  user-select: none;
}

.item-img-remake {
  position: absolute;
  bottom: -8px;
  right: 2px;
  pointer-events: none;
  user-select: none;
  filter: var(--app-filter);
}

.item-img-recipe {
  position: absolute;
  bottom: -6px;
  right: 0;
  width: 28px;
  height: 28px;
  pointer-events: none;
  user-select: none;
}

.item-center {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
  font-size: 15px;
}

.item-variants {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 2px;
}

.item-length {
  display: inline-block;
  font-size: 13px;
  font-weight: 0;
}

.item-check-btn {
  display: flex;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0 1rem 0 0.75rem;
  margin-left: auto;
  border: 0;
  outline: 0;
  background-color: transparent;

  &:focus .item-check {
    box-shadow: 0 0 0 2px #fff;
    border-color: transparent;
  }
}

.item-check {
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-color: var(--app-btn-gray2);
  border: none;
  border-radius: 0.25em;
  appearance: none;

  &.item-check-1 {
    background-image: var(--app-check);
    background-color: #42b983;
  }

  &.item-check-2 {
    background-image: var(--app-check);
    background-color: #3790ff;
  }
}

.item-note {
  font-weight: 400;
  font-size: 10px;
}

.t-heart {
  position: absolute;
  right: 4px;
  top: 0px;
  width: 12px;
  height: 12px;
  margin-bottom: 0.2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='%23eb486b'%3E%3Cpath d='M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z'/%3E%3C/svg%3E");
}

.t-stock {
  position: absolute;
  right: 2px;
  top: 14px;
  height: 16px;
  padding-right: 4px;
  padding-left: 4px;
  min-width: 16px;
  margin-bottom: 0.2rem;
  background-color: #4c8cda;
  color: var(--app-body-bg);
  border-radius: 99px;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
}

// Tile

.tile {
  display: inline;
}

.tile-variants {
  display: inline;
  padding-left: 0;

  ::v-deep .t:first-child .t {
    border-left: 1px solid var(--app-body-bg);
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  ::v-deep .t:last-child .t {
    border-right: 1px solid var(--app-body-bg);
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}

.t {
  display: inline;
  user-select: none;
}
</style>
